import { Component, HostListener } from '@angular/core';
import { DirtyTrackingService } from './core/dirty-tracking/dirty-tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent { 
  title = 'Angular';

  constructor(private dirty: DirtyTrackingService) {
  }

  @HostListener('window:beforeunload', ['$event'])
  BeforeUnload(event) {
    if(!this.dirty.isClean()){
        event.preventDefault();
    }
  }
}
